import React from 'react';
import '../../styles/pages.css';
import './LegalPages.css';

const LegalPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-page-hero">
        <div className="container">
          <h1>Mentions Légales</h1>
          <p>Informations légales conformément à la législation marocaine</p>
        </div>
      </section>
      
      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <p><strong>1.</strong> Identification de l'Entreprise. Dénomination sociale : B.R.F.B Services. Forme juridique : SARL AU. Registre de Commerce : 152695. Identifiant Fiscal (IF) : 66037040. Siège social : Résidence Saad Allah N 719, Talloujte II Amerciche, Marrakech. Téléphone : 06 61 09 75 19 / 06 89 13 91 09. Email : Brfbbureau@gmail.com.</p>

            <p><strong>2.</strong> Législation Applicable. Le présent site web est soumis à la législation marocaine, notamment la loi n° 09-08 relative à la protection des personnes physiques à l'égard du traitement des données à caractère personnel, la loi n° 53-05 relative à l'échange électronique de données juridiques, le Code de Commerce marocain et le Code des Obligations et Contrats.</p>

            <p><strong>3.</strong> Propriété Intellectuelle. L'ensemble des éléments composant ce site (textes, images, vidéos, logos, graphismes, etc.) est la propriété exclusive de B.R.F.B Services, sauf mention contraire. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable.</p>

            <p><strong>4.</strong> Protection des Données Personnelles. Ce site web ne stocke aucune donnée personnelle sur ses serveurs. Les informations saisies dans nos formulaires sont uniquement utilisées pour pré-remplir des messages WhatsApp ou emails, rediriger vers les applications de messagerie de l'utilisateur et faciliter la prise de contact directe. Aucune base de données n'est constituée. Les données transitent uniquement vers les services tiers choisis par l'utilisateur (Gmail, WhatsApp).</p>

            <p><strong>5.</strong> Responsabilité. B.R.F.B Services met tout en œuvre pour offrir aux utilisateurs des informations et/ou des outils disponibles et vérifiés, mais ne saurait être tenu pour responsable des erreurs, d'une absence de disponibilité des informations et/ou de la présence de virus sur son site.</p>

            <p><strong>6.</strong> Droit Applicable et Juridiction. Les présentes mentions légales sont régies par le droit marocain. En cas de litige, et après tentative de résolution amiable, les tribunaux marocains seront seuls compétents.</p>

            <p><strong>7.</strong> Contact. Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter par email : Brfbbureau@gmail.com, par téléphone : 06 61 09 75 19 ou 06 89 13 91 09, ou via WhatsApp en utilisant notre formulaire de contact.</p>

            <p><strong>Dernière mise à jour :</strong> Novembre 2025</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
